import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { AppProviders } from './shell';
import './styles/fonts.gen.css';
import './styles/main.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Failed to find the root element');
}
const app = /*#__PURE__*/ _jsx(React.StrictMode, {
    children: /*#__PURE__*/ _jsx(AppProviders, {
        children: /*#__PURE__*/ _jsx(RouterProvider, {
            router: router
        })
    })
});
// Marketing pages arrive prerendered (scripts/prerender.mjs): attach to that markup instead of
// replacing it. Everything else — the signed-in app, dev builds — starts from an empty root.
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
} else {
    ReactDOM.createRoot(rootElement).render(app);
}
